import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signupUser, checkPassword } from '../components/DataHandler'; // Import signupUser and checkPassword
import '../styles/Login.css';

const Login = () => {
    const [view, setView] = useState<'login' | 'signup' | 'forgot'>('login');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const data = await checkPassword(email, password);

            if (data.valid) {
                // Login success
                localStorage.setItem('token', data.token);
                localStorage.setItem('email', email);
                navigate('/overview');
            } else {
                // Login failed
                alert('이메일 또는 비밀번호가 올바르지 않습니다.');
            }
        } catch (error) {
            console.error('Login error:', error);
            alert('로그인 중 오류가 발생했습니다. 다시 시도해 주세요.');
        }
    };

    const handleSignupOrForgot = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await signupUser(email);
            alert(response.message);
            // Optionally switch back to login after success
            setView('login');
        } catch (error) {
            console.error('Error:', error);
            alert('서버 오류로 인해 요청을 처리할 수 없습니다.');
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                {view === 'login' ? (
                    <>
                        <h2 className="login-title">로그인</h2>
                        <p className="login-subtitle">i2r에 오신 것을 환영합니다</p>
                        <form onSubmit={handleLogin} className="login-form">
                            <div className="form-group">
                                <label htmlFor="email">이메일</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="이메일을 입력하세요"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="password">비밀번호</label>
                                <input
                                    type="password"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="비밀번호를 입력하세요"
                                    required
                                />
                                <div style={{ textAlign: 'right', marginTop: '5px' }}>
                                    <span
                                        style={{ color: '#007FFF', cursor: 'pointer', fontSize: '0.9rem' }}
                                        onClick={() => setView('forgot')}
                                    >
                                        비밀번호를 잊으셨나요?
                                    </span>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary login-btn">
                                로그인
                            </button>
                        </form>
                        <div className="login-footer">
                            <p>계정이 없으신가요? <span style={{ color: '#007FFF', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => setView('signup')}>회원가입</span></p>
                        </div>
                    </>
                ) : (
                    <>
                        <h2 className="login-title">
                            {view === 'signup' ? '회원가입' : '비밀번호 찾기'}
                        </h2>
                        <p className="login-subtitle">
                            가입한 이메일을 입력하시면 임시 비밀번호를 전송해 드립니다.
                        </p>
                        <form onSubmit={handleSignupOrForgot} className="login-form">
                            <div className="form-group">
                                <label htmlFor="email">이메일</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="이메일을 입력하세요"
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary login-btn">
                                임시 비밀번호 전송
                            </button>
                        </form>
                        <div className="login-footer">
                            <p><span style={{ color: '#007FFF', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => setView('login')}>로그인</span>으로 돌아가기</p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Login;
